import React, { useState } from "react";
import { submitUserFeedback } from "../../../../../backend/firebaseFunctions";
import "./UXFeedbackModal.css";

const UXFeedbackModal = ({ isOpen, onClose, userId }) => {
  const [feedback, setFeedback] = useState({
    satisfaction: 0,
    likes: "",
    improvements: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate satisfaction rating
    if (feedback.satisfaction === 0) {
      setErrors({ satisfaction: "נא לבחור דירוג שביעות רצון" });
      return;
    }

    try {
      setLoading(true);
      setSubmitError(null);
      await submitUserFeedback(userId, feedback);
      setSubmitted(true);
      setTimeout(() => {
        setSubmitted(false);
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Error submitting feedback:", error);
      setSubmitError("אירעה שגיאה בשליחת המשוב. אנא נסה שוב מאוחר יותר.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFeedback((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user makes a selection
    if (field === "satisfaction") {
      setErrors((prev) => ({ ...prev, satisfaction: "" }));
    }
  };

  if (!isOpen) return null;

  return (
    <div className="ux-feedback-modal-overlay" onClick={onClose}>
      <div className="ux-feedback-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ux-feedback-modal-header">
          <div className="ux-feedback-modal-header-left">
            <button className="ux-feedback-modal-close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="ux-feedback-modal-header-right">
            <h1 style={{ fontWeight: "bold" }}>משוב מאמנים</h1>
            <h4 style={{ fontWeight: "bold", direction: "rtl" }}>
              חוויית השימוש שלך חשובה לנו מאוד!
            </h4>
            <h5 style={{ fontWeight: "normal", direction: "rtl" }}>
              מילוי של המשוב יעזור לנו לשפר את המערכת כך שתתאים יותר אלייך
              ולצרכים שלך.
            </h5>
          </div>
        </div>
        <div className="ux-feedback-modal-body">
          {submitted ? (
            <div className="ux-feedback-submission-success">תודה רבה!</div>
          ) : (
            <form onSubmit={handleSubmit} className="ux-feedback-form">
              <div className="ux-feedback-form-section">
                <label className="ux-feedback-form-label">
                  כמה אתה מרוצה מהשימוש ב-SimplyCoach?*
                </label>
                <div className="ux-feedback-rating-container">
                  {[1, 2, 3, 4, 5].map((rating) => (
                    <button
                      key={rating}
                      type="button"
                      className={`ux-feedback-rating-button ${
                        feedback.satisfaction === rating ? "selected" : ""
                      }`}
                      onClick={() => handleChange("satisfaction", rating)}
                    >
                      {rating}
                    </button>
                  ))}
                </div>
                {errors.satisfaction && (
                  <div className="ux-feedback-error-message">
                    {errors.satisfaction}
                  </div>
                )}
              </div>

              <div className="ux-feedback-form-section">
                <label className="ux-feedback-form-label">
                  מה אתה הכי אוהב במערכת?
                </label>
                <input
                  type="text"
                  value={feedback.likes}
                  onChange={(e) => handleChange("likes", e.target.value)}
                  placeholder="ספר/י לנו"
                  className="ux-feedback-short-input"
                />
              </div>

              <div className="ux-feedback-form-section">
                <label className="ux-feedback-form-label">
                  מה אפשר לשפר או להוסיף במערכת?
                </label>
                <textarea
                  value={feedback.improvements}
                  onChange={(e) => handleChange("improvements", e.target.value)}
                  placeholder="באגים, רעיונות, או כל דבר אחר"
                  className="ux-feedback-long-input"
                />
              </div>
              <button
                type="submit"
                className="ux-feedback-submit-button"
                disabled={feedback.satisfaction === 0 || loading}
              >
                {loading ? "שולח..." : "שלח משוב"}
              </button>
              {submitError && (
                <div
                  className="ux-feedback-error-message"
                  style={{ textAlign: "center", marginBottom: "20px" }}
                >
                  {submitError}
                </div>
              )}
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default UXFeedbackModal;
